import TABS from '../../models/tabs.js';
import _ from 'lodash';

class NavbarController {
  constructor(roleService,intTypeValidationService, $state) {
    this.name = 'navbar';
    this.tabs = TABS;
    this.roleService = roleService;
    this.intTypeValidationService = intTypeValidationService;
    this.$state = $state;
    this.setActiveTab();
  }

  isAuthRequired() {
    return this.$state.current.authRequired;
  }

  isAuthorized(tabName) {
    let stateName = this.truncateTabName(tabName);
    return this.roleService.isAuthorized(stateName);
  }

  canView(tabName) {
    let stateName = this.truncateTabName(tabName);
    return this.intTypeValidationService.canView(stateName);
  }

  truncateTabName(tabName) {
    return tabName.split('(')[0];
  }

  setActiveTab(){
    this.deactivateTabs();
    let tab = _.find(this.tabs, this.findTabByName.bind(this)) || this.tabs[0];

    tab.active = true;
  }

  findTabByName(tab) {
    let tabStateName = this.truncateTabName(tab.stateName);
    return tabStateName === this.$state.current.name;
  }

  activateTab(tab) {
    this.deactivateTabs();
    tab.active = true;
  }

  deactivateTabs() {
    this.tabs.forEach((tab) => {
      tab.active = false;
    });
  }
}

NavbarController.$inject = ['roleService','intTypeValidationService', '$state'];

export default NavbarController;



// WEBPACK FOOTER //
// ./app/common/navbar/navbar.controller.js